import { createFetcherReducer } from '../utils';
import {
  LOADING_CONNECTIONS,
  RECEIVED_CONNECTIONS,
  RECEIVED_CONNECTIONS_FAILED,
} from '../../actions/types';

export default createFetcherReducer(
  LOADING_CONNECTIONS, RECEIVED_CONNECTIONS, RECEIVED_CONNECTIONS_FAILED,
);
